<app-page-layout [pageTitle]="title()">
  <div
    page-content
    class="page-content"
    [class.is-processing]="state() !== 'initial'"
  >
    <div class="bulk-container" [class.is-processing]="state() !== 'initial'">
      @if (isLoading()) {
        <app-upload-skeleton />
      } @else if (state() === 'initial') {
        <form [formGroup]="form" class="form-box">
          <a class="view-loads-tag" routerLink="/reporte">
            Ver Cargas Realizadas
            <i class="pi pi-arrow-right"></i>
          </a>
          <app-upload-step-one
            [formGroup]="form"
            [itemsTypeOperations]="itemsTypeOperations"
          />
          <div
            class="bulk-upload-container"
            [class.card-disabled]="isStepOneIncomplete"
          >
            <app-upload-template-card
              [isDisabled]="isDownloadDisabled"
              [isOpaque]="hasFile()"
              [isDownloading]="isDownloadingTemplate()"
              (download)="downloadTemplate()"
            />
            <app-upload-file-drop
              [hasFile]="hasFile()"
              [fileName]="file()?.name"
              [fileSizeMB]="fileSizeMB"
              [isDisabled]="isUploadAreaDisabled"
              [isUploadDisabled]="isUploadDisabled"
              (fileSelected)="onFileSelected($event)"
              (remove)="resetForm()"
              (upload)="initUpload()"
            />
          </div>
        </form>
      } @else {
        <app-processing-load
          [state]="state()"
          [loadId]="loadId()"
          [errorUploadFile]="errorUploadFile()"
          (newLoad)="onNewLoad()"
          (retryLoad)="onRetryLoad()"
          (downloadTemplateWithErrors)="onDownloadErrorTemplate()"
        />
      }
    </div>
  </div>
</app-page-layout>
